var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/** Т.к. при редактировании объекта бэк нам возвращает измененный объект,
 * мы в деталях самого объекта подменяем данные вместо перезапроса к серверу */
export var updateHandler = function (
/** Эндпоинт, который нужно обновить */
detailsEndpointName, 
/** Ключи аргументов, которые нужно извлечь из запроса, который вызывает обновление кеша для эндпоинта */
argKeys, 
/** Ссылка на api */
api, 
/**
 * Если имена аргументов не совпадают, то можно переопределить
 * Пример: запрос на добавление площадки в избранное в качестве идентификатора передает аргумент `favoriteId`.
 * При выполнении этого запроса нам нужно обновить кеш для эндпоинта `getPlaceById`, у которого аргумент идентификатора `id`.
 * Тогда в argKeys нужно передать `favoriteId`, а в mappedArgKeys нужно передать `id`.
 * Если аргументы совпадают, то передавать mappedArgKeys не нужно.
 */
mappedArgKeys) {
    var extractArgs = function (queryArg) {
        var extractedArgs = {};
        if (Array.isArray(argKeys)) {
            argKeys.forEach(function (key, idx) {
                var _a;
                var resultKey = (_a = mappedArgKeys === null || mappedArgKeys === void 0 ? void 0 : mappedArgKeys[idx]) !== null && _a !== void 0 ? _a : key;
                extractedArgs[resultKey] = queryArg[key];
            });
        }
        else {
            var resultKey = String(mappedArgKeys !== null && mappedArgKeys !== void 0 ? mappedArgKeys : argKeys);
            extractedArgs[resultKey] = queryArg[argKeys];
        }
        return extractedArgs;
    };
    return function (queryArg, _a) {
        var dispatch = _a.dispatch, queryFulfilled = _a.queryFulfilled;
        return __awaiter(void 0, void 0, void 0, function () {
            var data_1, args, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, queryFulfilled];
                    case 1:
                        data_1 = (_b.sent()).data;
                        args = extractArgs(queryArg);
                        dispatch(api.util.updateQueryData(detailsEndpointName, args, // Cast to never to satisfy TypeScript
                        function (draft) {
                            Object.assign(draft, data_1);
                        }));
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _b.sent();
                        console.error("Failed to update query data:", error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
};
/** Достаем все теги из всех эндпоинтов, чтобы сформировать список для enhancedApi */
export var getTags = function (endpoints) {
    var result = new Set();
    Object.entries(endpoints).forEach(function (el) {
        var _a, _b;
        (_a = el[1].invalidatesTags) === null || _a === void 0 ? void 0 : _a.forEach(function (t) { return result.add(t); });
        (_b = el[1].providesTags) === null || _b === void 0 ? void 0 : _b.forEach(function (t) { return result.add(t); });
    });
    return Array.from(result);
};
